import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setLoggedSPremiumUser } from "../components/Authentication/modules/actions";

const mapStateToProps = (state) => ({
  state: {
    loggedSPremiumUser: state.user.loggedSPremiumUser,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      setLoggedSPremiumUser,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
